(function ($) {
  'use strict';

  Drupal.behaviors.mppSortV1 = {
    attach: function (context, settings) {
      var self = this;
      var defaultSortOption = $('select.js-mpp-sort-menu', context).attr('data-default-sort');
      var queryString = '.js-mpp-sort-menu option[value=' + defaultSortOption + ']';
      // Add default sort value before changing init sorting
      var gridItems = $('.grid--mpp', context).find('.grid--mpp__item');

      for (var i = 0; i < gridItems.length; i++) {
        $(gridItems[i]).attr('data-default-sort-val', i);
      }
      if (gridItems.length !== 0) {
        $('body').addClass('has-sort-grid-menu');
      }

      // Init sort
      $(queryString, context).attr('selected', 'selected');

      var sortBy = $('.js-mpp-sort-menu option:selected', context).attr('value');
      var $gridMPP = $('.grid--mpp', context);
      // grid promo touts (only)
      var $gridItemTout = $('.grid--mpp__item:has(.node-elc-nodeblock)', context);
      var $selectMenu = $('.js-mpp-sort-menu', context);

      if (defaultSortOption != null) {
        sortBy = defaultSortOption;
      }
      self.sortProducts($gridMPP, '.grid--mpp__item', sortBy);

      $selectMenu.change(function () {
        sortBy = $(this).val();
        self.sortProducts($gridMPP, '.grid--mpp__item', sortBy);
      });

      // customizing behaviours for use with filters
      $(document).on('grid-filter-inactive', $selectMenu, function () {
        $selectMenu.parent().css('z-index', 100);
      });
      $(document).on('grid-filter-active', $selectMenu, function () {
        $selectMenu.parent().css('z-index', 1);
      });
      $(document).on('filters-active-closed', $selectMenu, function () {
        $selectMenu.parent().addClass('filters-closed');
        $selectMenu.parent().removeClass('filters-open');
      });
      $(document).on('filters-active-open', $selectMenu, function () {
        $selectMenu.parent().addClass('filters-open');
        $selectMenu.parent().removeClass('filters-closed');
      });
      $(document).trigger('grid-filter-inactive');

      // make sure promo touts stay in position
      $(document).on('ajaxComplete grid_items_default_position', $gridItemTout, function () {
        // product grid items (only)
        var $gridItemProduct = $('.grid--mpp__item:has(.product)', context);

        $gridItemTout.each(function (index) {
          var toutP = $(this).data('default-sort-val');

          $(this).detach().insertBefore($gridItemProduct[toutP - index]);
        });
      });
      // mobile only adjustments
      $(document).on('change ajaxComplete focusout', $selectMenu, function () {
        if ($selectMenu.parents('html, body').hasClass('device-mobile')) {
          // Get current breakpoint width
          var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
          // We only want to trigger below than medium
          var bPmediumUp = parseInt(Unison.fetch.all()['usn-medium'], 10);
          // only trigger above medium
          var is_mobile = currentBpWidth <= bPmediumUp;

          Unison.on('change', function (bp) {
            setTimeout(function () {
              // Get current breakpoint width
              var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
              // We only want to trigger below than medium
              var bPmediumUp = parseInt(Unison.fetch.all()['usn-medium'], 10);

              // only trigger above medium
              is_mobile = currentBpWidth <= bPmediumUp;
            }, 200);
          });
          if (!!is_mobile) {
            $('html, body').animate({ scrollTop: 0 }, 500, 'easeOutExpo');
          }
        }
      });

      $('.mpp-sort__container', context).insertBefore('.grid--mpp');
    },

    sortProducts: function (parent, childSelector, sortByW) {
      var priceSelector = '.product_header_details .product__price .product__price--standard';
      var percentageSelector = '.product_header_details .product__rating-percentage';
      var newestSelector = '[data-misc-flag]';
      var items = parent.children(childSelector).sort(function (a, b) {
        if (sortByW === 'display_newest') {
          var an = $(a).find('.product').attr('data-misc-flag-text');

          if (an === 'new') { // product badge NEW
            return -1;
          }

          return 1;
        } else if (sortByW === 'display_featured') {
          var an = Number($(a).attr('data-default-sort-val'));
          var bn = Number($(b).attr('data-default-sort-val'));

          return an < bn ? -1 : an > bn ? 1 : 0;
        } else if (sortByW === 'display_bestseller') {
          var an = $(a).find('.product').attr('data-misc-flag-text');

          if (an === 'best_seller') { // product badge BEST SELLER
            return -1;
          }

          return 1;
        } else if (sortByW === 'price_low_to_high') {
          var an = Number($(a).find(priceSelector).text().split(' - ')[0].replace(/[^0-9\.]+/g, ''));
          var bn = Number($(b).find(priceSelector).text().split(' - ')[0].replace(/[^0-9\.]+/g, ''));

          return an < bn ? -1 : an > bn ? 1 : 0;
        } else if (sortByW === 'price_high_to_low') {
          var an = Number($(a).find(priceSelector).text().split(' - ')[0].replace(/[^0-9\.]+/g, ''));
          var bn = Number($(b).find(priceSelector).text().split(' - ')[0].replace(/[^0-9\.]+/g, ''));

          return an < bn ? 1 : an > bn ? -1 : 0;
        } else if (sortByW === 'display_top_rated') {
          if ($(a).find(percentageSelector).length !== 0) {
            var an = Number($(a).find(percentageSelector).attr('style').replace(/[^0-9\.]+/g, ''));
          } else {
            var an = 0;
          }

          if ($(b).find(percentageSelector).length !== 0) {
            var bn = Number($(b).find(percentageSelector).attr('style').replace(/[^0-9\.]+/g, ''));
          } else {
            var bn = 0;
          }

          return an < bn ? 1 : an > bn ? -1 : 0;
        } else {
          return;
        }
      });

      parent.append(items);
      $(document).trigger('grid_items_default_position');
    }
  };
})(jQuery);
